import { createSelector } from 'reselect';
import studentSelector from './student';

export const isNewStudentSelector = createSelector(
    studentSelector,
    (student) => student && student.isNewStudent,
);
